import cookieStorage from 'cookie-storage'
import { useFt, useFlow, useAb } from 'hooks'
import { usePathname, useSearchParams } from 'router'
import { constants } from 'helpers'
import { getCouponFromQueryParams } from 'helpers/getters'

import getForcedCouponByPathname from './getForcedCouponByPathname'


const useLandingCouponCode = () => {
  const pathname = usePathname()
  const [ { cpn: queryCoupon } ] = useSearchParams()

  const isHomePlansAbEnabled = useAb(constants.abTests.homePlansV2) === 'b'

  const isDefaultCoupon50Enabled = useFt(constants.features.defaultCoupon50)
  const isHoliday22Sub60Enabled = useFt(constants.features.holiday22Sub60)

  const { isInfluencerFlow } = useFlow()

  let couponCode = getForcedCouponByPathname(pathname)

  if (!couponCode && queryCoupon) {
    couponCode = getCouponFromQueryParams(queryCoupon, isHomePlansAbEnabled)
  }

  const cookieCouponCode = cookieStorage.getItem(constants.cookieNames.discountCoupon)

  // queryCoupon may be null for 'none' param and undefined in case of invalid param
  if (couponCode === undefined) {
    if (cookieCouponCode !== undefined) {
      couponCode = cookieCouponCode
    }
    else if (isInfluencerFlow) {
      couponCode = 'HDR55INF'
    }
    else if (isHoliday22Sub60Enabled) {
      couponCode = 'HD60'
    }
    else if (isDefaultCoupon50Enabled) {
      couponCode = isHomePlansAbEnabled ? 'HD50CRE' : 'HD50'
    }
    else {
      couponCode = isHomePlansAbEnabled ? 'HD25CRE' : 'HD25'
    }
  }


  return couponCode
}


export default useLandingCouponCode
